import { render, staticRenderFns } from "./NxServices.vue?vue&type=template&id=dc29c7f0&scoped=true"
import script from "./NxServices.vue?vue&type=script&lang=js"
export * from "./NxServices.vue?vue&type=script&lang=js"
import style0 from "./NxServices.vue?vue&type=style&index=0&id=dc29c7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc29c7f0",
  null
  
)

export default component.exports